/* itg-enter-guard.js
 *
 * Stops the Enter key from adding a product to the cart.
 *
 * Why this is needed: the variant radios in snippets/product-variant-options.liquid
 * carry  form="{{ product_form_id }}"  so they are form-associated with the
 * add-to-cart form even though they sit outside it. Pressing Enter while any
 * such control has focus triggers the browser's IMPLICIT FORM SUBMISSION, which
 * fires the form's submit button - i.e. the product gets added to the cart just
 * from clicking a swatch and hitting Enter.
 *
 * The theme only guarded a few individual text inputs inline
 * (buy-buttons.liquid, engraving.liquid). This covers every control on every
 * cart form in one place.
 *
 * Enter is still allowed where it genuinely means "activate": a focused button,
 * a link, or a real submit input - and inside a textarea, where it means a new
 * line. Everything else attached to a /cart/add form is blocked.
 */
(function () {
  'use strict';

  if (window.ITG_ENTER_GUARD) return;
  window.ITG_ENTER_GUARD = true;

  function isCartForm(form) {
    if (!form) return false;
    var action = form.getAttribute('action') || '';
    // Matches /cart/add and market-prefixed variants like /en-gb/cart/add
    return action.indexOf('/cart/add') !== -1;
  }

  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Enter' && e.keyCode !== 13) return;

      // Mid-composition in an IME - Enter is confirming a character, not submitting.
      if (e.isComposing || e.keyCode === 229) return;

      var el = e.target;
      if (!el || !el.tagName) return;

      var tag = el.tagName.toUpperCase();

      // Enter means "new line" here.
      if (tag === 'TEXTAREA') return;

      // The shopper has deliberately focused something activatable - let it work.
      if (tag === 'BUTTON' || tag === 'A') return;

      if (tag === 'INPUT') {
        var type = (el.getAttribute('type') || el.type || '').toLowerCase();
        if (type === 'submit' || type === 'button' || type === 'image' || type === 'reset') return;
      }

      // el.form resolves the form= attribute too, so it catches the variant
      // radios that live outside the form element.
      var form = el.form || (el.closest ? el.closest('form') : null);
      if (!isCartForm(form)) return;

      e.preventDefault();
    },
    true
  );
})();